import { Box, Card, CardContent, Typography, Link as ExternalLink } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { ActionButton } from '../../../components'
import { useExternalApp } from '../../../hooks'

const cardShape = 'polygon(0% 0%, 100% 0%, 100% calc(100% - 25px), calc(100% - 25px) 100%, 0% 100%)'

const useStyles = makeStyles(({ palette, spacing }) => ({
  title: {
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '32px',
    color: '#000',
    marginBottom: spacing(2)
  },
  textOutline: {
    borderBottom: `5px solid ${palette.primary.main}`
  },
  card: {
    clipPath: cardShape,
    display: 'flex',
    borderRadius: 0
  },
  edge: {
    width: '100%',
    height: '100%',
    paddingRight: 1,
    paddingBottom: 1,
    clipPath: cardShape,
    backgroundColor: palette.grey.shade[20]
  },
  message: {
    letterSpacing: '0.13px'
  }
}))

const PaidPlansCTA = () => {
  const classes = useStyles()
  const { getMtUrl } = useExternalApp()

  return (
    <Box className={classes.edge}>
      <Card variant='elevation' classes={{ root: classes.card }}>
        <CardContent>
          <Typography className={classes.title}>
            <span className={classes.textOutline}>Join</span> Mindtools
          </Typography>
          <Typography className={classes.message}>
            Do you want to have full use of our library? Join Mindtools to get unlimited access to 2,500+ resources, including articles, quizzes, videos, infographics, and Expert Interviews - plus many other exclusive features and benefits!
          </Typography>
          <Box display='flex' flexDirection='row' mt={2} justifyContent='flex-end'>
            <ActionButton
              variant='secondary'
              label='See Plans'
              component={ExternalLink}
              href={getMtUrl('join')}
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default PaidPlansCTA
